import { render } from "./InitialPageContentSection.vue?vue&type=template&id=1a1f0d0a&scoped=true"
import script from "./InitialPageContentSection.vue?vue&type=script&lang=js"
export * from "./InitialPageContentSection.vue?vue&type=script&lang=js"

import "./InitialPageContentSection.vue?vue&type=style&index=0&id=1a1f0d0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1f0d0a"]])

export default __exports__